// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".required-star[data-v-5105ae05]{color:red;font-weight:700}textarea[data-v-5105ae05]{margin:1em auto;width:96%}.answer-outer-wrapper[data-v-5105ae05]{min-width:30%;background:#eee;border-radius:4px;padding:1em;cursor:pointer}img[data-v-5105ae05]{max-width:-moz-max-content;max-width:max-content;width:100%;border-radius:4px}", ""]);
// Exports
module.exports = exports;
